import { render, staticRenderFns } from "./sendPageIMG.vue?vue&type=template&id=44c6863e&scoped=true&"
import script from "./sendPageIMG.vue?vue&type=script&lang=js&"
export * from "./sendPageIMG.vue?vue&type=script&lang=js&"
import style0 from "./sendPageIMG.vue?vue&type=style&index=0&id=44c6863e&prod&scoped=true&lang=scss&"
import style1 from "./sendPageIMG.vue?vue&type=style&index=1&id=44c6863e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6863e",
  null
  
)

export default component.exports